// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"key-bpm-finder-player_wrapper__GNbLa","player":"key-bpm-finder-player_player__ivvn5"};